import { Controller } from "@hotwired/stimulus"

// "Seasonal product" checkbox: default OFF = available year-round.
// Checking reveals the date-range row; UNchecking hides it AND clears both
// dates, so saving genuinely returns the product to year-round (the model
// validates both-or-none). The hint text flips with the state:
//   off: "Check this box if your product is seasonal"
//   on:  "Uncheck this box if your product is available all year round"
export default class extends Controller {
  static targets = ["checkbox", "row", "start", "end", "hint"]
  static values = { hintOff: String, hintOn: String }

  connect() {
    this.toggle()
  }

  toggle() {
    const on = this.checkboxTarget.checked
    this.rowTarget.classList.toggle("hidden", !on)
    if (this.hasHintTarget) {
      this.hintTarget.textContent = on ? this.hintOnValue : this.hintOffValue
    }
    if (!on) {
      this.startTarget.value = ""
      this.endTarget.value = ""
    }
  }
}
